<template>
  <div class="w-full p-3 mb-10 custom-bg-green border border-green rounded-lg bg-blue-lightest"> <!-- Sales -->
    <div class="px-2 py-4 flex justify-between border-b"><!-- header -->
      <div class="w-full flex items-center">
        <input type="checkbox" class="green" :id="type + '_properties'" v-model="sub.subscription.enabled">
        <label :for="type + '_properties'" class="uppercase text-sm">Activate for {{ type }} Properties</label>
      </div>

      <button class="ml-auto py-1 px-6 uppercase text-white rounded text-sm" :class="[ sub.loading ? 'bg-green-light' : 'bg-green' ]" @click="$emit('save')" :disabled="sub.loading">
        {{ sub.loading ? 'Saving...' : 'Save' }}
      </button>
    </div> <!-- header end -->

    <div class="p-6"> <!-- inner start -->
      <div class="mb-6">
        <div class="flex items-center">
          <div class="mr-5">
            <input type="checkbox" class="blue" :id="type + '_email_notification'" v-model="sub.subscription.notification_enabled">
            <label :for="type + '_email_notification'" class="uppercase text-xs">Email notifications</label>
          </div>

          <input
            type="text"
            class="w-full rounded shadow p-3 border border-gray-light"
            placeholder="Enter email address"
            v-model.trim="sub.subscription.notification_email"
          />
        </div>
        <small class="block mt-2 text-red-dark">{{ sub.errors.get('notification_email') }}</small>
      </div>

      <div class="flex flex-wrap justify-between mb-6">
        <div class="my-4">
          <input type="checkbox" class="white" :id="type + '_exclude_land'" v-model="sub.subscription.exclude_repo_land">
          <label :for="type + '_exclude_land'" class="uppercase text-xxs">Exclude Repossessions &amp; Land</label>
        </div>
        <div class="my-4">
          <input type="checkbox" class="white" :id="type + 'exclude_comm'" v-model="sub.subscription.commerical_property">
          <label :for="type + 'exclude_comm'" class="uppercase text-xxs">Exclude Commerical Property</label>
        </div>
      </div>

      <div class="mb-6">
        <div class="w-full flex items-center">
          <div class="mr-4">
            <label for="" class="text-xs mb-2 block uppercase">For Properties From</label>
            <input v-model="sub.subscription.from" type="number" min="0" step="5000" class="input bg-white rounded w-full">
          </div>

          <span class="mr-4 mt-5 text-xs uppercase">To</span>

          <div class="pt-5">
            <input v-model="sub.subscription.to" type="number" min="0" step="5000" class="input bg-white rounded w-full">
          </div>
        </div>
        <small class="block mt-2 text-red-dark">{{ sub.errors.get('to') }}</small>
      </div>

      <div class="w-full flex items-center">
        <div class="mr-3">
          <label for="" class="text-xs mb-2 block uppercase">Create for properties with</label>
          <pl-select selectClass="bg-white w-64 rounded shadow" v-model="sub.subscription.images">
            <option :value="4">Four or more images</option>
            <option :value="5">Five or more images</option>
            <option :value="6">Six or more images</option>
            <option :value="7">Seven or more images</option>
            <option :value="8">Eight or more images</option>
          </pl-select>
          <small class="block mt-2 mb-1 text-grey-dark text-xs">
            A maximum of 10 images will be used
          </small>
        </div>
      </div>
    </div> <!-- inner end -->
  </div>
</template>

<script>
import { moneyFormat } from '@/helpers'

export default {
  name: 'Subscription',

  props: {
    value: {
      type: Object
    },
    type: {
      default: 'Sales'
    }
  },

  computed: {
    sub: {
      get () {
        return this.value
      },

      set (val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    moneyFormat
  }
}
</script>
